import React, { useCallback, useState } from "react";

import { IoIosArrowBack, IoIosArrowDown } from "react-icons/io";

import { Link as ReactLink, useHistory } from "react-router-dom";
import { Flex, Spacer, Text, Icon, Box, Link } from "@chakra-ui/react";
import { TbBellRinging } from "react-icons/tb";
import AvisosService from "../../../main/services/AvisosService";
import SemRegistros from "../SemRegistros";
import LoadingSpinner from "../LoadingSpinner";
import { useAuthProvider } from "../../../Context/AuthProvider";
import { PrintButtonAvisos } from "../PrintButtonAvisos";
import { TableCriancas } from "../TableCriancas";
import {
  criancaFunc,
  servicoAcolhimentoFunc,
} from "../../../helpers/Funcionalidades";
import Swal from "sweetalert2";

const ListItemAvisos = ({
  index,
  avisos,
  isPrinting,
  printingId,
  setIsPrinting,
  setPrintingId,
}) => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { roleKeycloack, user } = useAuthProvider();
  const [atualizarDadosTabela, setAtualizarDadosTabela] = useState(false);
  const history = useHistory();

  const destaquesPorAviso = {
    1: ["últimos 7 dias"],
    2: ["mais de 15 dias"],
    3: ["mais de 2 meses"],
    4: ["mais de 18 meses"],
    5: ["mais de 2 meses"],
    6: ["requisitos para adoção"],
    7: ["fora da sua área de atuação"],
  };

  const riscoAlert = (id, idPJCrianca, idMovimento) => {
    if (
      idMovimento !== 2 &&
      !roleKeycloack.includes(criancaFunc.pesquisarRisco) &&
      !(
        (roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
          roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(idPJCrianca)
      )
    ) {
      Swal.fire({
        title: "Por favor, entre em contato com o Gestor do MCA.",
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonColor: "#169499",
        cancelButtonText: "Voltar",
      });
    } else {
      history.push("/crianca/" + id);
    }
  };

  const columns = [
    {
      Header: "Nome/Nome Social",
      accessor: "nomeCrianca",
      Cell: (props) => {
        const id = props?.row?.original?.idCrianca;
        let name = props?.row?.original?.nomeCrianca;
        let ultimaMovimentacao = props?.row?.original?.movimentacoes[0];

        let temRiscoVida = false;
        let ultimaMovimentacaoRisco;

        if (ultimaMovimentacao?.idMovimento !== 2) {
          ultimaMovimentacaoRisco = props?.row?.original?.movimentacoes[0];
        }

        if (props?.row?.original?.nomeSocial) {
          name = name + " / " + props.row.original.nomeSocial;
        }

        if (
          props?.row?.original?.movimentacoes[0]?.idMovimento === 1 ||
          props?.row?.original?.movimentacoes[0]?.idMovimento === 6
        ) {
          const movimentacoes = props?.row?.original?.movimentacoes || [];

          for (const mov of movimentacoes) {
            if (mov?.idMovimento === 3 || !mov?.idMovimento) {
              temRiscoVida = mov?.riscoVidaMotivoSituacao === "S";
              break;
            }
          }
        }

        return (roleKeycloack &&
          roleKeycloack.includes(criancaFunc.visualizar)) ||
          roleKeycloack.includes(
            servicoAcolhimentoFunc.visualizarPartePPCAAM
          ) ? (
          (ultimaMovimentacaoRisco?.riscoVidaMotivoSituacao === "N" ||
            !ultimaMovimentacaoRisco?.riscoVidaMotivoSituacao) &&
          !temRiscoVida ? (
            <Link
              wordBreak={"break-all"}
              title={name}
              as={ReactLink}
              to={"/crianca/" + id}
            >
              <Flex alignItems="center" gap={2}>
                {ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" &&
                ultimaMovimentacao?.idMovimento === 2 ? (
                  <Box
                    w="4"
                    h="4"
                    bg="#169499"
                    borderRadius="full"
                    border="1px"
                    color="#169499"
                  />
                ) : ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" ||
                  ultimaMovimentacao?.descricaoTipoSituacao === "Desligado" ? (
                  <Box w="3" h="3" borderRadius="full" />
                ) : (
                  <Box
                    w="4"
                    h="4"
                    bg="red"
                    borderRadius="full"
                    border="1px"
                    color="red"
                  />
                )}
                <Text
                  display="flex"
                  h={"40px"}
                  alignItems={"center"}
                  minWidth="250px"
                >
                  {name}
                </Text>
              </Flex>
            </Link>
          ) : (
            <Link
              wordBreak={"break-all"}
              title={name}
              onClick={() =>
                riscoAlert(
                  id,
                  props?.row?.original?.servicoAcolhimento?.idPessoaJuridica,
                  props?.row?.original?.movimentacoes[0]?.idMovimento
                )
              }
            >
              <Flex alignItems="center" gap={2}>
                {ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" &&
                ultimaMovimentacao?.idMovimento === 2 ? (
                  <Box
                    w="4"
                    h="4"
                    bg="#169499"
                    borderRadius="full"
                    border="1px"
                    color="#169499"
                  />
                ) : ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" ||
                  ultimaMovimentacao?.descricaoTipoSituacao === "Desligado" ? (
                  <Box w="3" h="3" borderRadius="full" />
                ) : (
                  <Box
                    w="4"
                    h="4"
                    bg="red"
                    borderRadius="full"
                    border="1px"
                    color="red"
                  />
                )}
                <Text
                  display="flex"
                  h={"40px"}
                  alignItems={"center"}
                  minWidth="250px"
                >
                  {name}
                </Text>
              </Flex>
            </Link>
          )
        ) : ultimaMovimentacao?.riscoVidaMotivoSituacao === "N" ||
          !ultimaMovimentacao?.riscoVidaMotivoSituacao ? (
          <Flex alignItems="center" gap={2}>
            {ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" ||
            ultimaMovimentacao?.descricaoTipoSituacao === "Desligado" ? (
              <Box w="3" h="3" borderRadius="full" />
            ) : (
              <Box
                w="3"
                h="3"
                bg="red"
                borderRadius="full"
                F
                border="1px"
                color="red"
              />
            )}
            <Text
              display="flex"
              h={"40px"}
              alignItems={"center"}
              minWidth="250px"
            >
              {name}
            </Text>
          </Flex>
        ) : (
          <Flex alignItems="center" gap={2}>
            {ultimaMovimentacao?.descricaoTipoSituacao === "Acolhido" ||
            ultimaMovimentacao?.descricaoTipoSituacao === "Desligado" ? (
              <Box w="3" h="3" borderRadius="full" />
            ) : (
              <Box
                w="3"
                h="3"
                bg="red"
                borderRadius="full"
                border="1px"
                color="red"
              />
            )}
            <Text
              display="flex"
              h={"40px"}
              alignItems={"center"}
              minWidth="250px"
            >
              {name}
            </Text>
          </Flex>
        );
      },
    },
    {
      Header: "Idade",
      accessor: "idade",
      Cell: (props) => {
        return <Text>{props.value ?? ""}</Text>;
      },
    },
    {
      Header: "Filiação",
      accessor: "pais",
      sortType: (rowA, rowB, id, desc) => {
        const filiacoesA = rowA?.original?.filiacoes?.length
          ? rowA.original.filiacoes
              .map((filiacao) => filiacao?.filiacao?.nome || "")
              .reduce((prev, filiacao) => prev + filiacao, "")
          : "";
        const filiacoesB = rowB?.original?.filiacoes?.length
          ? rowB.original.filiacoes
              .map((filiacao) => filiacao?.filiacao?.nome || "")
              .reduce((prev, filiacao) => prev + filiacao, "")
          : "";
        return filiacoesA.localeCompare(filiacoesB, "pt-BR");
      },
      Cell: (props) => {
        return props?.value
          .sort((a, b) =>
            a.descricaoTipoRelacionamento.localeCompare(
              b.descricaoTipoRelacionamento
            )
          )
          .map((filiacao, index) => {
            return (
              <React.Fragment key={index}>
                <span style={{ whiteSpace: "nowrap" }}>
                  {filiacao?.nome}{" "}
                  <Text as="span" textTransform="capitalize">
                    ({filiacao?.descricaoTipoRelacionamento.toLowerCase()})
                  </Text>
                </span>
                {props.value.length - 1 !== index && <br />}
              </React.Fragment>
            );
          });
      },
    },
    {
      Header: "Serviço de Acolhimento",
      accessor: "servicoAcolhimento",
      sortType: (rowA, rowB, id, desc) => {
        const nomeServicoA = rowA?.original?.servicoAcolhimento
          ? rowA.original.servicoAcolhimento.nomeFantasia
          : "";
        const nomeServicoB = rowB?.original?.servicoAcolhimento
          ? rowB.original.servicoAcolhimento.nomeFantasia
          : "";
        return nomeServicoA?.localeCompare(nomeServicoB, "pt-BR");
      },
      Cell: (props) => {
        const permissaoServico =
          roleKeycloack.includes(criancaFunc.visualizarTudo) ||
          roleKeycloack.includes(
            servicoAcolhimentoFunc.visualizarPartePPCAAM
          ) ||
          roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteMP) ||
          roleKeycloack.includes(servicoAcolhimentoFunc.visualizarParteTJ) ||
          ((roleKeycloack.includes(criancaFunc.visualizarTudoAcolhimento) ||
            roleKeycloack.includes(criancaFunc.visualizarTudoTutelar)) &&
            user?.orgaoExterno?.includes(
              props?.row?.original?.servicoAcolhimento?.idPessoaJuridica
            ));
        let temRiscoVida = false;

        if (
          props?.row?.original?.movimentacoes[0]?.idMovimento === 1 ||
          props?.row?.original?.movimentacoes[0]?.idMovimento === 2 ||
          props?.row?.original?.movimentacoes[0]?.idMovimento === 6
        ) {
          const movimentacoes = props?.row?.original?.movimentacoes || [];

          for (const mov of movimentacoes) {
            if (mov?.idMovimento === 3 || !mov?.idMovimento) {
              temRiscoVida = mov?.riscoVidaMotivoSituacao === "S";
              break;
            }
          }
        }

        if (
          (props?.row?.original?.movimentacoes[0]?.riscoVidaMotivoSituacao ===
            "S" &&
            !permissaoServico) ||
          (!permissaoServico &&
            (props?.row?.original?.movimentacoes[0]?.idMovimento === 1 ||
              props?.row?.original?.movimentacoes[0]?.idMovimento === 2 ||
              props?.row?.original?.movimentacoes[0]?.idMovimento === 6) &&
            temRiscoVida)
        ) {
          return <span></span>;
        } else {
          const idServico = props?.row?.original?.servicoAcolhimento?.id;
          if (!idServico) {
            return <span></span>;
          } else {
            return (
              <>
                {roleKeycloack &&
                roleKeycloack.includes(servicoAcolhimentoFunc.visualizar) ? (
                  <Link
                    wordBreak={"break-word"}
                    title={
                      props.value
                        ? props.value.nomeFantasia +
                          `${
                            props?.value?.suspenso === "S" ? " (Suspenso)" : ""
                          }`
                        : ""
                    }
                    as={ReactLink}
                    to={"/servico-acolhimento/" + idServico}
                  >
                    <Text>
                      {" "}
                      {props.value
                        ? props.value.nomeFantasia +
                          `${
                            props?.value?.suspenso === "S" ? " (Suspenso)" : ""
                          }`
                        : ""}
                    </Text>
                  </Link>
                ) : (
                  <Text>
                    {props.value
                      ? props.value.nomeFantasia +
                        `${props?.value?.suspenso === "S" ? " (Suspenso)" : ""}`
                      : ""}
                  </Text>
                )}
              </>
            );
          }
        }
      },
    },
  ];

  const getDadosTipoAviso = useCallback(
    async (idTipoAviso) => {
      setLoading(true);

      const TipoAviso = {
        1: "ACOLHIDOS_ULTIMOS_7_DIAS",
        2: "ACOLHIDOS_15_DIAS_SEM_REGISTRO_CIVIL",
        3: "ACOLHIDOS_2_MESES_SEM_PROCESSO_JUDICIAL",
        4: "ACOLHIDOS_MAIS_18_MESES",
        5: "ACOLHIDOS_SEM_VISITA_2_MESES",
        6: "ACOLHIDOS_REQUISITOS_ADOCAO",
        7: "ACOLHIDOS_FORA_AREA_ATUACAO",
      };

      const tipoAviso = TipoAviso[idTipoAviso];

      try {
        const storage = JSON.parse(
          sessionStorage.getItem(`avisos${index}-filter`)
        );

        const valuesToSend = {
          pageSize: storage?.pageSize ? storage?.pageSize : "",
          page: storage?.page ? storage.page : "",
          sortField: storage?.sort ? storage?.sort : "nomeCrianca",
          sortType: storage?.desc ? storage?.desc : "ASC",
        };

        sessionStorage.setItem(
          `avisos${index}-filter`,
          JSON.stringify({
            ...storage,
            sort: storage?.sort ?? "nomeCrianca",
            desc: storage?.desc ?? false,
          })
        );
        sessionStorage.setItem(
          "table-crianca",
          JSON.stringify([{ id: "nomeCrianca", desc: false }])
        );

        await AvisosService.getTiposAvisosPaginado(
          tipoAviso,
          valuesToSend
        ).then((res) => {
          sessionStorage.setItem(`avisos${index}-filterSearch`, true);
          const tempObj = JSON.parse(
            sessionStorage.getItem(`avisos${index}-filter`)
          );

          sessionStorage.setItem(
            `avisos${index}-filter`,
            JSON.stringify({
              ...tempObj,
              totalItems: res.data.totalElements,
              totalPages: res.data.totalPages,
            })
          );

          setData(res.data);
        });
      } catch (error) {
        setData([]);
      } finally {
        setLoading(false);
      }
    },
    [index]
  );

  return (
    <>
      <Flex
        id={avisos?.idTipoAviso}
        bgColor={open ? "#16949933" : "#F0F0F099"}
        mt="10px"
        px="20px"
        py="16px"
        border={"solid 1px #DEE2E6"}
        borderTop={open ? "solid 3px #169499" : ""}
        alignItems="center"
        cursor={isPrinting ? "not-allowed" : "pointer"}
        opacity={isPrinting ? 0.6 : 1}
        onClick={() => {
          if (isPrinting) return;
          setOpen(!open);
          !open && getDadosTipoAviso(avisos?.idTipoAviso);
        }}
      >
        <TbBellRinging size={21} color="#5689A6" fontWeight="bold" />

        <Text
          color={"#1A203D"}
          fontWeight="500"
          fontSize="14px"
          lineHeight="21.6px"
          ml={3}
        >
          {avisos?.descricaoTipoAviso &&
            avisos.descricaoTipoAviso
              .split(
                new RegExp(
                  `(${destaquesPorAviso[avisos.idTipoAviso].join("|")})`,
                  "gi"
                )
              )
              .map((parte, i) =>
                destaquesPorAviso[avisos.idTipoAviso].some(
                  (dest) => parte.toLowerCase() === dest.toLowerCase()
                ) ? (
                  <strong key={i}>{parte}</strong>
                ) : (
                  parte
                )
              )}
        </Text>
        <Spacer />
        {/* <Box
          mr="15px"
          onClick={(e) => {
            if (loadingPrint) return;
            setLoadingPrint(true);
            e.stopPropagation();
          }}
          cursor={loadingPrint ? "not-allowed" : "pointer"}
          pointerEvents={loadingPrint ? "none" : "auto"}
          opacity={loadingPrint ? 0.5 : 1}
          _hover={
            !loadingPrint
              ? {
                  transform: "scale(1.1)",
                  color: "#169499",
                  transition: "all 0.2s ease-in-out",
                }
              : {}
          }
        >
          <PrintButtonAvisos
            idTipoAviso={avisos?.idTipoAviso}
            loadingPrint={loadingPrint}
            setLoadingPrint={setLoadingPrint}
          />
        </Box> */}
        <Box
          mr="15px"
          onClick={(e) => {
            if (isPrinting) return;
            setIsPrinting(true);
            setPrintingId(avisos?.idTipoAviso);
            e.stopPropagation();
          }}
          cursor={isPrinting ? "not-allowed" : "pointer"}
          pointerEvents={isPrinting ? "none" : "auto"}
          opacity={isPrinting && printingId !== avisos?.idTipoAviso ? 0.5 : 1}
          _hover={
            !isPrinting
              ? {
                  transform: "scale(1.1)",
                  color: "#169499",
                  transition: "all 0.2s ease-in-out",
                }
              : {}
          }
        >
          <PrintButtonAvisos
            idTipoAviso={avisos?.idTipoAviso}
            isPrinting={isPrinting}
            printingId={printingId}
            setIsPrinting={setIsPrinting}
            setPrintingId={setPrintingId}
          />
        </Box>

        {!open ? (
          <Icon
            aria-label="Files"
            color="#169499"
            as={IoIosArrowBack}
            boxSize="20px"
          />
        ) : (
          <Icon
            aria-label="Files"
            color="#169499"
            as={IoIosArrowDown}
            boxSize="20px"
          />
        )}
      </Flex>
      {open && (
        <>
          {!loading ? (
            <>
              {data?.content && data?.content?.length > 0 ? (
                <TableCriancas
                  index={index}
                  data={data.content}
                  columns={columns}
                  entidade={`avisos${index}`}
                  atualizarDadosTabela={atualizarDadosTabela}
                  setAtualizarDadosTabela={setAtualizarDadosTabela}
                  roleKeycloack={roleKeycloack}
                  user={user}
                  setData={setData}
                  disableHeaderOptionsOpcoes
                />
              ) : (
                <Box mt={4}>
                  <SemRegistros half buttonVisible={true} />
                </Box>
              )}
            </>
          ) : (
            <Box mt={4}>
              <LoadingSpinner />
            </Box>
          )}
        </>
      )}
    </>
  );
};

export default ListItemAvisos;
